// Shared by the browser save request and server validation. Source ownership,
// lifecycle fields and generated output are never editable through this contract.
module.exports = Object.freeze({
    page: Object.freeze(['blockly']),
    profileMenu: Object.freeze(['blockly']),
    navigation: Object.freeze(['children']),
    namespace: Object.freeze(['title', 'prettyName', 'relations', 'withCustomApi', 'hideApiDocs'])
});
